import * as React from "react";
import Svg, { Path } from "react-native-svg";
const FlagIcon = ({ customColor = "#4EB826", ...props }) => (
  <Svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M9.5987 3.99935L9.33203 2.66602H3.33203V13.9993H4.66536V9.33268H8.3987L8.66536 10.666H13.332V3.99935H9.5987Z"
      fill={customColor}
    />
  </Svg>
);
export default FlagIcon;
